import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { ageVerificationSchema } from "@common/components/helpers/validation-schemas/ageVerificationSchema";
import useCompliance from "./useCompliance";
import AgeVerificationAction from "@common/redux/actions/AgeVerificationAction";

const useAgeVerification = () => {
  const data = useSelector((state) =>
    AgeVerificationAction.getStatePath(state),
  );

  // Two flags controlled from System Admin in CMS Desktop:
  const {
    config: { hasChildrenInGamingArea, hasNoIdCustomerDescription },
  } = useSelector((state) => AgeVerificationAction.getStatePath(state));

  const methods = useForm({
    defaultValues: data,
    resolver: yupResolver(
      ageVerificationSchema({
        hasChildrenInGamingArea,
        hasNoIdCustomerDescription,
      }),
    ),
    mode: "all",
  });

  const { resetComplianceForms } = useCompliance(methods);

  const onBack = () => resetComplianceForms();

  return {
    data,
    methods,
    onBack,
  };
};

export default useAgeVerification;
